import type { SubscriptionTier } from "@/lib/api";

/**
 * Decides what happens when the user clicks the Invite button on the Account
 * tab. Single-seat tiers (`starter`, `locked_free`) always see the upgrade
 * modal. Multi-seat tiers (`trial`, `partner_trial`, `vip_trial`, `pro_trial`,
 * `pro`, `enterprise`) show the real invite dialog for privileged roles.
 *
 * - `'invite'` → open `InviteDialog` to send a real invitation
 * - `'upgrade'` → open the upgrade modal (`TrialAudienceUpgradeModal` with
 *   `variant="team-invite"`)
 * - `'hidden'` → render nothing (non-admin members on team plans, missing
 *   profile, etc.)
 */
export function resolveInviteMode(
  tier: SubscriptionTier | undefined,
  orgRole: string | undefined,
): "invite" | "upgrade" | "hidden" {
  if (tier === "starter" || tier === "locked_free") {
    return "upgrade";
  }
  const isPrivilegedRole = orgRole === "owner" || orgRole === "admin";
  if (
    (tier === "trial" ||
      tier === "partner_trial" ||
      tier === "vip_trial" ||
      tier === "pro_trial" ||
      tier === "pro" ||
      tier === "enterprise") &&
    isPrivilegedRole
  ) {
    return "invite";
  }
  return "hidden";
}
